const SITE_NAME = "FurciFood";
const PROD_SITE_NAME = "FurciFood - L'altro modo di mangiare";
const FURCI_FOOD_SK =
  "$2a$12$34dqHpHssfiJKukaFMoyQu8ASh9sCITQv3by7LT.pflrxf9VrxKKy";

const profiles = {
  local: "local",
  development: "development",
  testing: "testing",
  preproduction: "preproduction",
  production: "production",
};

const getRouteBasename = () => {
  return process.env.PUBLIC_URL;
};

const getProfileActive = () => {
  let currentProfile = profiles.local;
  switch (process.env.REACT_APP_ACTIVE_PROFILE) {
    case profiles.local:
      currentProfile = profiles.local;
      break;
    case profiles.development:
      currentProfile = profiles.development;
      break;
    case profiles.testing:
      currentProfile = profiles.testing;
      break;
    case profiles.preproduction:
      currentProfile = profiles.preproduction;
      break;
    case profiles.production:
      currentProfile = profiles.production;
      break;
    default:
      currentProfile = profiles.local;
  }

  return currentProfile;
};

const profilesActive = getProfileActive();

const getApiUrl = () => {
  let apiUrl = "";
  switch (profilesActive) {
    case profiles.local:
      apiUrl = "http://localhost:8080";
      break;
    case profiles.development:
      apiUrl = "https://dev.ynosit.it:1999/furcifood-3.0.0.8";
      break;
    case profiles.testing:
      apiUrl = "https://test.ynosit.it:1993/furcifood-3.0.0.8";
      break;
    case profiles.preproduction:
      apiUrl = "https://pre.ynosit.it:1999/furcifood-3.0.0.8";
      break;
    case profiles.production:
      apiUrl = "https://prod.ynosit.it:1993/furcifood-3.0.0.8";
      break;
    default:
      apiUrl = "http://localhost:8080";
  }
  return apiUrl;
};

const getAssetsBaseUrl = () => {
  let apiUrl = "";
  switch (profilesActive) {
    case profiles.local:
      // apiUrl = "http://localhost:8080";
      apiUrl = "https://dev.ynosit.it:1997/assets/furcifood";
      break;
    case profiles.development:
      apiUrl = "https://dev.ynosit.it:1997/assets/furcifood";
      break;
    case profiles.testing:
      apiUrl = "https://test.ynosit.it:1991/assets/furcifood";
      break;
    case profiles.preproduction:
      apiUrl = "https://pre.ynosit.it:1997/assets/furcifood";
      break;
    case profiles.production:
      apiUrl = "https://prod.ynosit.it:1991/assets/furcifood";
      break;
    default:
      apiUrl = "http://localhost:8080";
  }
  return apiUrl;
};

const getTitle = () => {
  if (getProfileActive() !== profiles.production) {
    return `${SITE_NAME} - ${profilesActive.toLocaleUpperCase()} ENV`;
  } else {
    return `${PROD_SITE_NAME}`;
  }
};

const getSitenameDNS = () => {
  let feUrl = "";
  switch (profilesActive) {
    case profiles.local:
      feUrl = "http://localhost:3000";
      break;
    case profiles.development:
      feUrl = "https://dev.ynosit.it:1997";
      break;
    case profiles.testing:
      feUrl = "https://test.ynosit.it:1991";
      break;
    case profiles.preproduction:
      feUrl = "https://pre.ynosit.it:1997";
      break;
    case profiles.production:
      feUrl = "https://www.furcifood.it";
      break;
    default:
      feUrl = "http://localhost:3000";
  }
  return feUrl + process.env.PUBLIC_URL;
};

export const PROFILE = profilesActive;
export const ASSETS_BASE_URL = getAssetsBaseUrl();
export const BASENAME = getRouteBasename();
export const TITLE = getTitle();
export const META_TITLE = PROD_SITE_NAME;
export const META_SITE_NAME = SITE_NAME;
export const META_SITE_NAME_DNS = getSitenameDNS();
export const META_SITE_NAME_DESC =
  "FurciFood è un progetto esclusivo, nato dall'idea di mettere in contatto diretto e costante specifiche esigenze alimentari del consumatore con i professionisti della filiera gastronomica alternativa...";
export const API_URL = getApiUrl();
export const SECRET_KEY = FURCI_FOOD_SK;
export const ROUTES = {
  HOME_PATH: "/",
  FURCINET_PATH: "/furcinet",
  JOIN_PATH: "/aderisci",
  SUGGEST_PATH: "/suggerisci",
  DETTAGLIO_PATH: "/dettaglio",
  FURCIFOOD_PATH: "/furcifood",
  FURCY_PATH: "/furcy",
  // BLOG_PATH: "/article",
  FURCINER_PATH: "/furciner",
  CONTATTACI_PATH: "/contattaci",
  FAQ_PATH: "/faq",
  TERMINI_PATH: "/termini-e-condizioni",
};
